module.exports = __webpack_public_path__ + "img/edit_filters.dc4942c.png";